import { render } from "./ConversationReviewDialog.vue?vue&type=template&id=0ffa39ce&lang=pug"
import script from "./ConversationReviewDialog.vue?vue&type=script&lang=js"
export * from "./ConversationReviewDialog.vue?vue&type=script&lang=js"

import "./ConversationReviewDialog.vue?vue&type=style&index=0&id=0ffa39ce&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__